import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

/**
 * Safe wrapper around Firebase Analytics logEvent.
 * No-ops if analytics is not initialized (dev / emulator mode).
 * IMPORTANT: Never pass PII (email addresses, user IDs, quote contents).
 */
function track(eventName, params = {}) {
  if (!analytics) return;
  try {
    logEvent(analytics, eventName, params);
  } catch (err) {
    console.warn(`Analytics event "${eventName}" failed:`, err.message);
  }
}

export const trackSoftwareViewed = (softwareName, category) =>
  track('software_viewed', { software_name: softwareName, category });

export const trackSearchPerformed = (queryLength) =>
  track('search_performed', { query_length: queryLength });

export const trackCategoryBrowsed = (categoryName) =>
  track('category_browsed', { category_name: categoryName });

export const trackQuoteUploadStarted = () =>
  track('quote_upload_started');

export const trackQuoteSubmitted = (softwareName) =>
  track('quote_submitted', { software_name: softwareName });

export const trackLoginCompleted = (method) =>
  track('login_completed', { method });
